/* eslint-disable react/prop-types */
import React, { useMemo, useState } from 'react'

import { CCol, CFormInput, CRow } from '@coreui/react-pro'
import { CFormInputProps } from '@coreui/react-pro/dist/components/form/CFormInput'
import { mdiCircle, mdiEye, mdiEyeOff } from '@mdi/js'
import Icon from '@mdi/react'
import { omit } from 'lodash'

import { battleshipGrey, black, greyX, red, skyBlue } from '@constants/colors'
import { IPasswordInput } from '@interfaces/components/molecules/PasswordInput'

import './styles.scss'

const PasswordInput = (
  props: CFormInputProps & React.RefAttributes<HTMLInputElement> & IPasswordInput,
) => {
  const [passwordVisible, setPasswordVisible] = useState(false)
  const [inputFocused, setInputFocused] = useState(false)

  const rulesList = useMemo(() => {
    const value = (props.value as string) || ''
    return [
      { text: 'One lowercase character', enabled: /[a-z]/.test(value) },
      { text: 'One uppercase character', enabled: /[A-Z]/.test(value) },
      { text: 'One number', enabled: /\d/.test(value) },
      {
        text: 'One special character !@#$%^&*',
        enabled: /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(value),
      },
      { text: '8 characters minimum', enabled: value.length >= 8 },
    ]
  }, [props.value])
  return (
    <div className="PICustomInputGroup">
      <CFormInput
        {...omit(props, 'showRules')}
        type={passwordVisible ? 'text' : 'password'}
        onFocus={() => {
          setInputFocused(true)
        }}
        onBlur={() => {
          setInputFocused(false)
        }}
      />
      <div
        className={!props?.invalid ? 'PIEyeIcon' : 'PIEyeIconError'}
        onClick={() => setPasswordVisible(!passwordVisible)}
      >
        <Icon path={passwordVisible ? mdiEyeOff : mdiEye} color={battleshipGrey} size={1} />
      </div>
      {props.showRules && (inputFocused || props.value || props.invalid) ? (
        <div className="PIRulesContainer">
          <CRow>
            {rulesList.map((rule) => {
              let dotColor = greyX
              let textColor = greyX
              if (rule.enabled) {
                dotColor = skyBlue
                textColor = black
              } else if (props.invalid) {
                dotColor = red
                textColor = red
              }
              return (
                <CCol
                  key={rule.text}
                  md={6}
                  sm={12}
                  className="d-flex align-items-center caption-font"
                >
                  <Icon className="me-2" path={mdiCircle} color={dotColor} size={0.3} />
                  <div style={{ color: textColor }}>{rule.text}</div>
                </CCol>
              )
            })}
          </CRow>
        </div>
      ) : null}
    </div>
  )
}

export default PasswordInput
